/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `done` - Wykonana
 * * `skipped_phase1_errors` - Pominięta — błędy fazy 1
 * * `aborted_race` - Przerwana — wyścig
 */
export type BulkPhase2OutcomeEnum = typeof BulkPhase2OutcomeEnum[keyof typeof BulkPhase2OutcomeEnum];


export const BulkPhase2OutcomeEnum = {
  done: 'done',
  skipped_phase1_errors: 'skipped_phase1_errors',
  aborted_race: 'aborted_race',
} as const;
